import { createHttpClient } from '@adapters/HttpClient';
import { useToast } from '@shared/hooks/use-toast';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { CourierFilesApiAdapter } from '../adapters';
import { extractApiErrorMessage } from '../lib/extractApiErrorMessage';
import { UploadCourierFileRequest, UploadCourierFileResponse } from '../models';

export const useUploadCourierFile = () => {
  const { toast } = useToast();
  const { t } = useTranslation('codCourierFiles');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: UploadCourierFileRequest): Promise<UploadCourierFileResponse> => {
      const httpClient = createHttpClient(apiClientWH);
      const adapter = new CourierFilesApiAdapter(httpClient);
      return adapter.uploadCourierFile(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['courier-cod-files'] });
    },
    onError: (error: unknown) => {
      const errorMessage = extractApiErrorMessage(error, t('upload.error.unexpected', 'Ocurrió un error inesperado'));

      toast({
        title: t('upload.error.title', 'Error al subir archivo'),
        description: errorMessage,
        variant: 'destructive',
      });
    },
  });

  return {
    uploadCourierFile: mutation.mutate,
    uploadCourierFileAsync: mutation.mutateAsync,
    isUploading: mutation.isPending,
  };
};
